import { render, staticRenderFns } from "./PrizePacks.vue?vue&type=template&id=a08c9068&scoped=true&"
import script from "./PrizePacks.vue?vue&type=script&lang=js&"
export * from "./PrizePacks.vue?vue&type=script&lang=js&"
import style0 from "./PrizePacks.vue?vue&type=style&index=0&id=a08c9068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08c9068",
  null
  
)

export default component.exports